import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FinanciacionPropiaService } from './financiacion-propia.service';
import { AddFileService } from '../../../shared/components/add-file/add-file.service';
import { LocalDB } from '../../../shared/utils';
import { FinanciacionPropiaModel } from './financiacion-propia.model';
import { AccountMovementsViewModel } from '../../accounting/models/accounting-movement.model';
import { consts } from '../../../consts';
import { NotificationService } from '../../../modules_v2/shared/services/notification.service';

@Component({
    selector: 'convfact-financiacionpropiaattachment',
    templateUrl: './financiacion-propia-dialog-attachment.component.html',
    styleUrls: ['../financiacion-privada/financiacion-dialogs.component.css'],
    standalone: false
})
export class FinanciacionPropiaDialogAttachmentComponent {

  public uid: string;
  public descripcion: string;

  public originEntity: string = "Finanzas";
  public loadingFile = false;
  public errorMessage = '';

  constructor(
    public dialogRef: MatDialogRef<FinanciacionPropiaDialogAttachmentComponent, boolean>,
    public financiacionPropiaService: FinanciacionPropiaService,
    private addFileService: AddFileService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notify: NotificationService,
  ) {
    this.uid = data.uid;
    this.descripcion = data.descripcion || '';
  }

  public uploadFile(event: any): void {
    const input = event.target as HTMLInputElement;
    const fileList: FileList = input.files;
    if (!fileList || fileList.length === 0 || this.loadingFile) return;

    const file: File = fileList[0];
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);

    this.errorMessage = '';
    this.setLoading(true);

    this.addFileService.attachFile(formData, this.originEntity)
      .then(response => {
        if (response.error) {
          throw { message: response.message };
        }

        LocalDB.RemoveForFiles();

        const fileUid = response.uid;

        const financiacionPropia: FinanciacionPropiaModel = {
          carencia: 0,
          bankAccountsUid: consts.EMPTY_GUID,
          accountingModelsCortoPlazoNumber: "",
          accountingModelsLargoPlazoNumber: "",
          cuentaContableACrear: "",
          descripcion: "",
          importeInicial: 0,
          importePendiente: 0,
          fechaConstitucion: new Date(),
          fechaFinalizacion: new Date(),
          plazo: 0,
          tipoInteres: 0,
          uid: this.uid,
          tipoLiquidaciones: 0,
          filesFinanciacionPropiaUid: fileUid,
          duracion: 0,
          comisionApertura: 0,
          partnersId: 0,
          partnersName: '',
          manualMovement: new AccountMovementsViewModel()
        };

        return this.financiacionPropiaService.editFileAttachment(financiacionPropia);
      })
      .then(result => {
        if (result !== true) {
          throw { message: 'No se ha podido adjuntar el fichero' };
        }
        this.setLoading(false);
        this.notify.ok('Se ha adjuntado el fichero correctamente');
        this.dialogRef.close(true);
      })
      .catch(error => {
        this.setLoading(false);
        input.value = '';
        this.errorMessage = (error && error.error && error.error.message) || (error && error.message) || 'No se ha podido adjuntar el fichero';
      });
  }

  public closeDialog(): void {
    if (this.loadingFile) return;
    this.dialogRef.close(false);
  }

  private setLoading(loading: boolean): void {
    this.loadingFile = loading;
    this.dialogRef.disableClose = loading;
  }
}
